import {
  type TransactionGroup,
  Transaction_Type,
} from "schema/gen/es/chiikipoint/model/v2/model_pb";
import { css } from "../../../../styled-system/css";
import { formatTimestamp } from "../../../libs/date";
import { t } from "../../../libs/i18n";
import { formatNumber } from "../../../libs/utils";
import { Cell } from "./cell";
import { CellFundSources } from "./cell-fundsources";

type PaymentTransactionDetailProps = {
  transactionGroup: TransactionGroup;
};

export function PaymentTransactionDetail({
  transactionGroup,
}: PaymentTransactionDetailProps) {
  const summaryDetail = transactionGroup.transactionDetails[0];
  const store = summaryDetail.store;

  if (!store) {
    return null;
  }

  // ここは支払いのみのトランザクションを集計する
  // Redeemを含めると、相殺して0ptとなってしまう。
  const amount = transactionGroup.transactionDetails
    .filter((d) => d.transaction?.type === Transaction_Type.PAYMENT)
    .reduce((acc: number, ts) => acc + Number(ts.transaction?.amount || 0), 0);

  return (
    <div
      className={css({
        bg: "white",
        px: "16px",
        rounded: "16px",
      })}
    >
      <Cell label={t("取引種別")} value={t("お支払い")} />
      <Cell
        label={t("支払いポイント")}
        value={`${formatNumber(-amount)}pt`}
        styles={{
          borderBottom: "none",
        }}
      />
      <CellFundSources transactionGroup={transactionGroup} />
      <Cell label={t("店舗名")} value={store.name} />
      <Cell
        label={t("支払い日時")}
        value={formatTimestamp(summaryDetail.transaction?.createdAt)}
      />
      <Cell label={t("取引ID")} value={transactionGroup.id} lastChild={true} />
    </div>
  );
}
